module.exports = __webpack_public_path__ + "static/media/majorA7.18f763c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA7.wav
// module id = GItl
// module chunks = 0